import { xlint_config } from 'xshell/xlint.js'

// eslint-disable-next-line no-restricted-exports
export default [xlint_config]
